if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // MAX QTY LOGIC
        const variantId = this.variantIdInput.value;
        const cartItems = document.querySelectorAll('.cart-item');
        let productFoundInCart = false;

        for (const item of cartItems) {
          const itemVariant = item.getAttribute('data-variant');
          const itemQty = parseInt(item.getAttribute('data-qty'), 10);
          const qtyError = item.querySelector('.cart-item__qty-error');

          if (itemVariant === variantId) {
            productFoundInCart = true;

            if (itemQty >= 8) {
                const quickAddModals = document.querySelectorAll('.quick-add-modal');
                quickAddModals.forEach(modal => {
                    modal.removeAttribute('open');
                });
                if (qtyError) qtyError.classList.add('active');
                document.querySelector('cart-drawer').open();

                return;
            } else {
              const addToCartBlock = this.closest('.quick-add-modal__add-to-cart') || this.closest('product-info');
              if (addToCartBlock) {
                const quantityInput = addToCartBlock.querySelector('.quantity__input');
                if (quantityInput) {
                  const quantityValue = parseInt(quantityInput.value, 10);
                  console.log(quantityValue);
                  const totalQty = itemQty + quantityValue;
                  console.log(totalQty);
                  if (totalQty <= 8) {
                    console.log("product add to the cart");
                  } else {
                    const quickAddModals = document.querySelectorAll('.quick-add-modal');
                    quickAddModals.forEach(modal => {
                      modal.removeAttribute('open');
                    });
                    if (qtyError) qtyError.classList.add('active');
                    document.querySelector('cart-drawer').open();
                    return;
                  }
                }
              }
            }
          }
        }
        if (!productFoundInCart) {
          const addToCartBlock = this.closest('.quick-add-modal__add-to-cart') || this.closest('product-info');
          if (addToCartBlock) {
              const quantityInput = addToCartBlock.querySelector('.quantity__input');
              if (quantityInput) {
                  const quantityValue = parseInt(quantityInput.value, 10);
                  if (quantityValue > 8) {
                      const quickAddModal = this.closest('.quick-add-modal') || this.closest('product-info');
                      if (quickAddModal) {
                          const qtyError = quickAddModal.querySelector('.quick-add-modal__qty-error');
                          if (qtyError) {
                            qtyError.classList.add('active');
                          }
                          const qtyErrorPdp = quickAddModal.querySelector('.product__qty-error');
                          if (qtyErrorPdp) {
                            qtyErrorPdp.classList.add('active');
                          }
                      }
                      return;
                  } else {
                    const quickAddModal = this.closest('.quick-add-modal') || this.closest('product-info');
                    if (quickAddModal) {
                        const qtyError = quickAddModal.querySelector('.quick-add-modal__qty-error');
                        if (qtyError) {
                            qtyError.classList.remove('active');
                        }
                        const qtyErrorPdp = quickAddModal.querySelector('.product__qty-error');
                        if (qtyErrorPdp) {
                            qtyErrorPdp.classList.remove('active');
                        }
                    }
                }
              }
          }
        }
        // END MAX QTY LOGIC

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        let formData;
        let itemIndex = 1;

        //Add BOGO to Cart
        const bogoParent = !this.closest('.complementary-products__container') ? this.closest('product-info')?.querySelector('[data-bogo-selector]') || this.closest('section')?.querySelector('product-info')?.querySelector('[data-bogo-selector]') : null;
        const bogoNotBundleParent = !this.closest('.complementary-products__container') ? this.closest('product-info')?.querySelector('[data-bogo-not-bundle]') || this.closest('section')?.querySelector('product-info')?.querySelector('[data-bogo-not-bundle]') : null;

        // Additional variant for product offer page
        const visualQauntityParent = !this.closest('.complementary-products__container') ? this.closest('product-info')?.querySelector('visual-quantity-selects') || this.closest('section')?.querySelector('product-info')?.querySelector('visual-quantity-selects') : null;
        const discountOfferInput = this.form.querySelector('input[name="properties[_discountOffer]"]');
        const discountOfferRegularPDP = this.form.querySelector('input[name="properties[_discountOfferRegularPDP]"]');
        const additionalVariantId = discountOfferInput?.value?.trim();
        const discountOfferVariantId = visualQauntityParent?.dataset.quantityVariantId;
        const discountOfferQuantityInputElement = visualQauntityParent?.querySelector('input:checked');
        const discountOfferQuantityInputValue = discountOfferQuantityInputElement ? discountOfferQuantityInputElement.value : 1;

        // Combined listing
        const combinedListingParent = !this.closest('.complementary-products__container') ? this.closest('product-info')?.querySelector('combined-listing') || this.closest('section')?.querySelector('product-info')?.querySelector('combined-listing') : null;

        if (bogoNotBundleParent) {
          formData = new FormData();

          const setVariantsParent = document.querySelector('[data-set-variants]');

          setVariantsParent.querySelectorAll('input.js-option-value-id').forEach(input => {
            const inputValue = input.value;
            if (inputValue) {
              formData.append(`items[${itemIndex}][id]`, `${inputValue}`);
              formData.append(`items[${itemIndex}][quantity]`, 1);
              if (discountOfferInput) {
                formData.append(`items[${itemIndex}][properties][_discountOffer]`, 'BOGO_BUNDLE');
              }
              itemIndex++;
            }
          });
        } else if (bogoParent) {
          formData = new FormData();
          // const setVariantsParent = document.querySelector('[data-set-variants]');

          // setVariantsParent.querySelectorAll('input.js-option-value-id').forEach(input => {
          //   const inputValue = input.value;
          //   if (inputValue) {
          //     formData.append(`items[${itemIndex}][id]`, `${inputValue}`);
          //     formData.append(`items[${itemIndex}][quantity]`, 1);
          //     itemIndex++;
          //   }
          // });
          const bogoInput = document.querySelector('input[data-bogo-quantity]:checked'),
          bogoQuantity = bogoInput.dataset.bogoQuantity,
          bogoVariantId = bogoInput.value;
          formData.append(`items[${itemIndex}][id]`, `${bogoVariantId}`);
          formData.append(`items[${itemIndex}][quantity]`, `${bogoQuantity}`);
          if (discountOfferInput) {
            formData.append(`items[${itemIndex}][properties][_discountOffer]`, 'BOGO');
          }
          itemIndex++;
        } else if (visualQauntityParent) {
          formData = new FormData();

          formData.append(`items[${itemIndex}][id]`, `${discountOfferVariantId}`);
          formData.append(`items[${itemIndex}][quantity]`, discountOfferQuantityInputValue);
          if (additionalVariantId && /^\d+$/.test(additionalVariantId)) {
            formData.append(`items[${itemIndex}][properties][_discountOffer]`, additionalVariantId);
          }

          if (discountOfferRegularPDP) {
            formData.append(`items[${itemIndex}][properties][_discountOfferRegularPDP]`, discountOfferRegularPDP.value);
          }

          itemIndex++;
        } else if (combinedListingParent) {
          const checkedInput = combinedListingParent.finalListingValue;

          if (checkedInput == 'currentProduct') {
            formData = new FormData(this.form);
          } else {
            formData = new FormData();

            const inputValue = checkedInput;
            formData.append(`items[${itemIndex}][id]`, `${inputValue}`);
            formData.append(`items[${itemIndex}][quantity]`, 1);

            itemIndex++;
          }
        } else {
          formData = new FormData(this.form);
        }

        if (additionalVariantId && /^\d+$/.test(additionalVariantId) && (!visualQauntityParent.hasAttribute('data-min-quantity-additional-variant') || visualQauntityParent.getAttribute('data-min-quantity-additional-variant') <= discountOfferQuantityInputValue)) {
          let additionalVariantInCart = false;

          document.querySelectorAll('.cart-item').forEach(item => {
            if (item.getAttribute('data-variant') === additionalVariantId) {
              additionalVariantInCart = true;
            }
          });

          if (!additionalVariantInCart) {
            formData.append(`items[${itemIndex}][id]`, additionalVariantId);
            formData.append(`items[${itemIndex}][quantity]`, 1);
          }
        }

        const additionalVarId = sessionStorage.getItem('additionalVariantId');
        const quantityInputElement = this.closest('.quick-add-modal__add-to-cart')?.querySelector('.quantity__input') || this.closest('product-info')?.querySelector('.quantity__input');
        const quantityInputValue = quantityInputElement ? quantityInputElement.value : 1;

        const skipAdditionalVarId = this.submitButton.classList.contains('quick-add__submit') && !this.submitButton.closest('#product-form-quick-add-modal') && !this.submitButton.closest('.product__sticky-atc');
        if (additionalVarId && !skipAdditionalVarId) {
          formData.append(`items[${itemIndex}][id]`, `${additionalVarId}`);
          formData.append(`items[${itemIndex}][quantity]`, quantityInputValue);

          const discountMixedBOGO = this.closest('product-info')?.querySelector('[data-mixed-bogo]')?.querySelector('input[name="properties[_discountMixedBOGO]"]');
          if (discountMixedBOGO) {
            formData.append(`items[${itemIndex}][properties][_discountMixedBOGO]`, discountMixedBOGO.value);
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    document.querySelector('cart-drawer-items').updateGifts(document.querySelector('#CartDrawer .gifts').dataset.total);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              document.querySelector('cart-drawer-items').updateGifts(document.querySelector('#CartDrawer .gifts').dataset.total);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
